// Copyright (c) 2016 Deere & Company

import PartReturnsSettings from '../../user/part-returns-settings/state-connector';

export default {
    component: PartReturnsSettings,
    name: 'PART_REQUESTS',
    path: 'part-returns'
};



// WEBPACK FOOTER //
// ./src/routes/settings/part-returns.js